"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var lodash_1 = __importDefault(require("lodash"));
var config_1 = require("./config");
var createPseudo = function (pseudo, props) {
    var _a;
    var theme = props.theme, rest = __rest(props, ["theme"]);
    if (lodash_1.default.isEmpty(rest))
        return;
    return (0, react_1.css)((_a = {}, _a[pseudo] = (0, config_1.stylesConfig)(__assign({ theme: theme }, rest)), _a));
};
var pseudos = function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return (0, react_1.css)(createPseudo('::after', __assign({ theme: theme }, props._after)), createPseudo('::before', __assign({ theme: theme }, props._before)), createPseudo('::placeholder', __assign({ theme: theme }, props._placeholder)), createPseudo(':active', __assign({ theme: theme }, props._active)), createPseudo(':checked', __assign({ theme: theme }, props._checked)), createPseudo(':disabled', __assign({ theme: theme }, props._disabled)), createPseudo(':first-of-type', __assign({ theme: theme }, props._firstOfType)), createPseudo(':focus', __assign({ theme: theme }, props._focus)), createPseudo(':focus-within', __assign({ theme: theme }, props._focusWithin)), createPseudo(':hover', __assign({ theme: theme }, props._hover)), createPseudo(':indeterminate', __assign({ theme: theme }, props._indeterminate)), createPseudo(':last-of-type', __assign({ theme: theme }, props._lastOfType)), createPseudo(':required', __assign({ theme: theme }, props._required)));
};
exports.default = pseudos;
